/** @flow */
import * as React from 'react';
import styled from 'styled-components';

/** Custom import's */
import t from '../../../application/translate';

const { Component } = React;

const Result = styled.div.attrs({
  className: 'text-center text-3xl font-semibold px-4 pb-3 text-green bg-grey-bg',
})``;

const ButtonDiv = styled.div.attrs({
  className: 'text-center text-grey mx-auto',
})`
  width: 100%;
  padding: 0 40px;
  padding-bottom: 90px;
  @media screen and (min-width: 425px) {
    width: 340px;
    padding: 0;
  }
`;

class Result4 extends Component<Props & ProvidedProps, State> {

  render() {

    return (
      <div>
        <Result>{t('visaCheckingForm/result4/part1')}</Result>
        <Result>{t('visaCheckingForm/result4/part2')}</Result>
        <ButtonDiv>
          {t('visaCheckingForm/info')}
        </ButtonDiv>
      </div>
    );
  }

}

export default Result4;



// WEBPACK FOOTER //
// ./src/components/VisaCheckingForm/results/Result4.js